/** returns selectable Countries as options */

export const countryOptions = (options: never[], key = "id", label = "name") => {
  return options.map((option) => ({
    value: option[key],
    label: option[label],
  }));
};
